import { Anchor, Row, Col, Flex, Tooltip, Button } from "antd";
import React, { useState, useEffect } from "react";
import useFetch from "../../server/useFetch";
import query from "../../server/constants.api";
import { styled } from "styled-components";
import {
  PageContent,
  PageSection,
  AnchorSection,
} from "../../styles/global/Pages.styled";
import { Widget } from "../Global/Atomics/Widget";
import { Text } from "../Global/Atomics/Text";
import { SelectAtomic } from "../Global/Atomics/SelectAtomic";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Theme from "../../styles/Theme/Theme";
import CustomIcon from "../Global/Icons/CustomIcon";
import Spinner from "../Global/Atomics/Spinner";
import { useGlobalFilterContext } from "../../contexts/GlobalFilterProvider";
import { isEmpty } from "../../utils/hooks/isEmpty";
import MouseoverTooltip from "../Global/Atomics/MouseoverTooltip";
import { generateYearList } from "../../utils/hooks/generateYeas";

const { Link } = Anchor;
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const MapWrapper = styled.div`
  height: ${(props) =>
    props.$marginTop ? "calc(100% - " + props.$marginTop + ")" : "100%"};
  margin-top: ${(props) => (props.$marginTop ? props.$marginTop : "0")};
  padding: 0;
  width: -webkit-fill-available;
`;
//#endregion
export const Homepage = () => {
  const { t } = useTranslation();
  const [tags, setTags] = useState([]);
  const [yearsToFetch, setYearsToFetch] = useState(new Date().getFullYear());
  const [pageSections, setPageSections] = useState([]);
  const { dropdownEntities, dropdownSubEntities, entityToFetch, subEntityToFetch, handleSubEntitiesOptionsChange, entityCoordinates, handleEntitiesOptionsChange } = useGlobalFilterContext();
  const [tooltipContent, setTooltipContent] = useState(null);
  const [cirisMostRecentYear, setCirisMostRecentYear] = useState(null);
  
  const { data: cirisEntityDates, refetch: refetchCirisEntityDates } = useFetch(
    query.path.municipalitiesDropdown,
    "getCIRISMunicipalitiesForDropdown"
  );

  useEffect(() => {
    if (i18next.resolvedLanguage === "pt") {
      setTooltipContent({
        iconText: [
          { bgColor: "chart-medium-1", text: "Edifícios" },
          { bgColor: "chart-medium-2", text: "Infraestruturas" },
          { bgColor: "chart-medium-3", text: "Iluminação Pública" },
        ],
      });
    } else {
      setTooltipContent({
        iconText: [
          { bgColor: "chart-medium-1", text: "Buildings" },
          { bgColor: "chart-medium-2", text: "Infrastructures" },
          { bgColor: "chart-medium-3", text: "Street Lighting" },
        ],
      });
    }
  }, [i18next.resolvedLanguage]);

  useEffect(() => {
    try {
      const localStorageTags = localStorage.getItem(`adeporto_tags`);
      if (localStorageTags !== "undefined") {
        const localStorageTagsParse = JSON.parse(localStorageTags);
        setTags(localStorageTagsParse);
      }
    } catch (error) {
      console.error(
        "(Homepage page) Error in useEffect setting localStorageTags:",
        error
      );
      //reportError(error); // Send error report to backend
    }
  }, []);

  useEffect(() => {
    let anchorArray = [
      {
        id: "autarchy",
        href: "#autarchy",
        title: t("autarchy"),
        key: "autarchy",
      },
      {
        id: "territory",
        href: "#territory",
        title: t("territory"),
        key: "territory",
      },
      {
        id: "emissions",
        href: "#emissions",
        title: t("emissions"),
        key: "emissions",
      },
    ];
    let newArray = [];
    if (entityToFetch) {
      newArray.push({
        id: "entity",
        href: "#entity",
        title: t("entity"),
        key: "entity",
      });
    }
    if (subEntityToFetch) {
      anchorArray.map((item) =>
        tags?.includes(item.id)?.toString() ? newArray.push(item) : null
      );
    }
    setPageSections(newArray);
    // setIsToFetchEmissionsBySector(false);
    if (cirisEntityDates?.data && entityToFetch) {
      console.log("Ciris Entity Dates: ", cirisEntityDates);
      const selectedEntityCiris = cirisEntityDates?.data?.find(
        (x) => x.tenant === entityToFetch?.value
      );
      const cirisYears = selectedEntityCiris?.years;
      setCirisMostRecentYear(Number(cirisYears?.[cirisYears.length - 1]));
    }
  }, [entityToFetch, subEntityToFetch]);

  // useEffect(() => {
  //     const adjustSectionPadding = () => {
  //       const subheader = document.querySelector('.subheader');
  //       const sections = document.querySelectorAll('.section');

  //       if (subheader) {
  //         const subheaderHeight = subheader.offsetHeight;
  //         sections.forEach(section => {
  //           section.style.paddingTop = subheaderHeight + 'px';
  //         });
  //       }
  //     };

  //     // Chame a função para ajustar o padding ao carregar a página
  //     adjustSectionPadding();

  //     // Chame a função sempre que o tamanho da janela mudar
  //     window.addEventListener('resize', adjustSectionPadding);

  //     return () => {
  //       // Remova o event listener ao desmontar o componente
  //       window.removeEventListener('resize', adjustSectionPadding);
  //     };
  //   }, [pageSections]);

  return (
    // className={loading ? 'full-h' : ''}
    <PageContent>
      <div className="solve-error-first" id="entity"></div>
      {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
      {tags?.length > 0 ? (
        <AnchorSection
          $backgroundColor="neutral-1"
          className="fixed-top subheader"
        >
          <Row align="middle" gutter={16}>
            <Col span={14}>
              <Anchor
                replace={true}
                direction="horizontal"
                items={pageSections}
              />
            </Col>
            {dropdownEntities?.length > 0 ? (
              <>
                <Col span={2} offset={isEmpty(dropdownSubEntities) ? 4 : 0}>
                  <Flex justify="flex-end" horizontal="true">
                    {/* <Text $fontColor='coolgray-10' $fontSize='text_lg' $weight='regular'>{t('year')} {moment().year()}</Text> */}
                    <SelectAtomic
                      optionsData={generateYearList(2022)}
                      handleOptionsChange={(value) => setYearsToFetch(value)}
                      defaultValue={yearsToFetch}
                      fullWidth={true}
                    />
                  </Flex>
                </Col>
                <Col span={4}>
                  <SelectAtomic
                    optionsData={dropdownEntities}
                    handleOptionsChange={(value, record) =>
                      handleEntitiesOptionsChange(record)
                    }
                    defaultValue={entityToFetch?.value}
                    fullWidth={true}
                  />
                </Col>
                {isEmpty(dropdownSubEntities) ? null : (
                  <Col span={4}>
                    <SelectAtomic
                      optionsData={dropdownSubEntities}
                      handleOptionsChange={(value, record) =>
                        handleSubEntitiesOptionsChange(record)
                      }
                      defaultValue={subEntityToFetch?.value}
                      fullWidth={true}
                    />
                  </Col>
                )}
              </>
            ) : (
              <Col span={10}>
                <Flex justify="center">
                  <Spinner stroke="green" size="28px" />
                </Flex>
              </Col>
            )}
          </Row>
        </AnchorSection>
      ) : null}
      <div className="ant-anchors-content">
        <>
          {entityToFetch && tags?.includes("entity") ? (
            <PageSection className="section ant-anchors-content-item">
              <a href=""></a>
              <Flex gap={16} vertical="true">
                <Text
                  $fontColor="coolgray-12"
                  $fontSize="text_xl"
                  $weight="regular"
                >
                  {t("entity")}
                </Text>
                <Row gutter={[32, 32]}>
                  <Col span={6}>
                    <Flex gap={16} vertical="true">
                      <Widget
                        data={{
                          height: "150px",
                          width: "auto",
                          background: "white",
                          title: "anualElectricityConsumption", //Traduções
                          icon: "Bolt",
                          description: null,
                          tooltip: t("accumulatedTooltip"),
                          charts: [
                            {
                              chartType: "bigNumberChart",
                              height: "100%",
                              width: "100%",
                              chartId: "bigNumberChartOne",
                              chartQuery:
                                "/unified_temporary/home/anualConsomeOfElectricity",
                              idQuery: "getAnnualConsumptionOfElectricity",
                            },
                          ],
                        }}
                        municipalitiesToFetch={
                          subEntityToFetch?.value ?? entityToFetch?.value
                        }
                        yearsToFetch={yearsToFetch}
                      />
                      <Widget
                        data={{
                          height: "150px",
                          width: "auto",
                          background: "white",
                          title: "anualGasConsumption", //Traduções
                          icon: "Gas",
                          description: null,
                          tooltip: t("accumulatedTooltip"),
                          charts: [
                            {
                              chartType: "bigNumberChart",
                              height: "auto",
                              width: "100%",
                              chartId: "bigNumberChartOne",
                              chartQuery:
                                "/unified_temporary/home/anualConsumeOfGas",
                              idQuery: "getAnnualConsumeOfGas",
                            },
                          ],
                        }}
                        municipalitiesToFetch={
                          subEntityToFetch?.value ?? entityToFetch?.value
                        }
                        yearsToFetch={yearsToFetch}
                      />
                      <Widget
                        data={{
                          height: "150px",
                          width: "auto",
                          background: "white",
                          title: "anualCO2Emissions", //Traduções
                          icon: "Emissions",
                          description: null,
                          tooltip: t("accumulatedTooltip"),
                          charts: [
                            {
                              chartType: "bigNumberChart",
                              height: "auto",
                              width: "100%",
                              chartId: "bigNumberChartOne",
                              chartQuery:
                                "/unified_temporary/home/consumeEvolution",
                              idQuery: "getAnnualEmissions",
                            },
                          ],
                        }}
                        municipalitiesToFetch={
                          subEntityToFetch?.value ?? entityToFetch?.value
                        }
                        yearsToFetch={yearsToFetch}
                      />
                    </Flex>
                  </Col>
                  <Col span={12}>
                    <Widget
                      data={{
                        height: "482px",
                        background: "white",
                        title: "monthlyElectricityConsumption",
                        icon: "Bolt",
                        charts: [
                          {
                            chartType: "columnsChartApex",
                            chartId: "stackedColumnsChartApexOne",
                            chartQuery:
                              "/unified_temporary/home/averageConsumeForMonth",
                            idQuery: "getAverageConsumeForMonth",
                          },
                        ],
                      }}
                      municipalitiesToFetch={
                        subEntityToFetch?.value ?? entityToFetch?.value
                      }
                      yearsToFetch={yearsToFetch}
                    />
                  </Col>
                  <Col span={6}>
                    <Widget
                      data={{
                        id: "Emissões por sector",
                        cols: 12,
                        height: "482px",
                        width: "auto",
                        background: "white",
                        // border: 'neutral-3',
                        title: "installationsByVoltageLevel", //Traduçoes
                        icon: "Bolt",
                        description: null,
                        tooltip: (
                          <MouseoverTooltip
                            data={{
                              iconText: [
                                { text: t("BTN: Low Normal Voltage") },
                                { text: t("BTN-IP: Low Normal Voltage in Public Lighting") },
                                { text: t("BTE: Special Low Voltage") },
                                { text: t("MT: Medium Voltage") },
                                { text: t("AT: High Voltage") },
                              ],
                            }}
                          />
                        ),
                        charts: [
                          {
                            chartType: "simpleDonutChartApex",
                            height: "100%",
                            width: "100%",
                            chartQuery:
                              "/unified_temporary/home/assetsByVoltageLevel",
                            idQuery: "getAssetsByVoltageLevel",
                            chartId: "donutChartOne",
                          },
                        ],
                      }}
                      municipalitiesToFetch={
                        subEntityToFetch?.value ?? entityToFetch?.value
                      }
                      yearsToFetch={yearsToFetch}
                    />
                  </Col>
                </Row>
              </Flex>
              <div className="solve-error" id="autarchy"></div>
              {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
            </PageSection>
          ) : null}
          {subEntityToFetch ? (
            <>
              {tags?.includes("autarchy") ? (
                <PageSection className="ant-anchors-content-item section">
                  <Flex gap={16} vertical="true">
                    <Row
                      gap={32}
                      style={{ $marginBottom: "1rem", alignItems: "center" }}
                    >
                      <Col span={20}>
                        <Text
                          $fontColor="coolgray-12"
                          $fontSize="text_xl"
                          $weight="regular"
                        >
                          {t("autarchy")}
                        </Text>
                      </Col>
                    </Row>
                    <Flex gap={32} vertical="true">
                      <Row gutter={[32, 32]}>
                        <Col span={6}>
                          <Flex gap={16} vertical="true">
                            <Widget
                              data={{
                                height: "150px",
                                width: "auto",
                                background: null,
                                border: "neutral-3",
                                title: "anualElectricityConsumption", //Traduções
                                icon: "Bolt",
                                description: null,
                                tooltip: t("accumulatedTooltip"),
                                charts: [
                                  {
                                    chartType: "bigNumberChart",
                                    height: "100%",
                                    width: "100%",
                                    chartId: "bigNumberChartOne",
                                    chartQuery:
                                      "/unified_temporary/home/anualConsomeOfElectricity",
                                    idQuery:
                                      "getAutharchyAnnualConsumptionOfElectricity",
                                  },
                                ],
                              }}
                              municipalitiesToFetch={entityToFetch?.value}
                              yearsToFetch={yearsToFetch}
                            />
                            <Widget
                              data={{
                                height: "150px",
                                width: "auto",
                                background: null,
                                border: "neutral-3",
                                title: "anualGasConsumption", //Traduções
                                icon: "Gas",
                                description: null,
                                tooltip: t("accumulatedTooltip"),
                                charts: [
                                  {
                                    cols: 24,
                                    chartType: "bigNumberChart",
                                    height: "auto",
                                    width: "100%",
                                    chartId: "bigNumberChartOne",
                                    chartQuery:
                                      "/unified_temporary/home/anualConsumeOfGas",
                                    idQuery: "getAutharchyAnnualConsumeOfGas",
                                  },
                                ],
                              }}
                              municipalitiesToFetch={entityToFetch?.value}
                              yearsToFetch={yearsToFetch}
                            />
                            <Widget
                              data={{
                                id: 14,
                                cols: 24,
                                height: "150px",
                                width: "auto",
                                background: null,
                                border: "neutral-3",
                                title: "anualCO2Emissions", //Traduções
                                icon: "Emissions",
                                description: null,
                                tooltip: t("accumulatedTooltip"),
                                charts: [
                                  {
                                    cols: 24,
                                    chartType: "bigNumberChart",
                                    height: "auto",
                                    width: "100%",
                                    chartId: "bigNumberChartOne",
                                    chartQuery:
                                      "/unified_temporary/home/consumeEvolution",
                                    idQuery: "getAutarchyAnnualEmissions",
                                  },
                                ],
                              }}
                              municipalitiesToFetch={entityToFetch?.value}
                              yearsToFetch={yearsToFetch}
                            />
                          </Flex>
                        </Col>
                        <Col span={6}>
                          <Flex gap={16} vertical="true">
                            <Widget
                              data={{
                                height: "150px",
                                border: "neutral-3",
                                title: "contractsOfElectricitity", //Traduções
                                icon: "Bolt",
                                tooltip: t("contractsOfElectricitityTooltip"),
                                charts: [
                                  {
                                    chartType: "bigNumberChart",
                                    chartId: "bigNumberChartOne",
                                    chartQuery:
                                      "/unified_temporary/home/activeContrats",
                                    idQuery: "getElectricityActiveContrats",
                                  },
                                ],
                              }}
                              municipalitiesToFetch={entityToFetch?.value}
                              yearsToFetch={yearsToFetch}
                            />
                            <Widget
                              data={{
                                height: "150px",
                                border: "neutral-3",
                                title: "gasContracts", //Traduções
                                icon: "Gas",
                                tooltip: t("gasContractsTooltip"),
                                charts: [
                                  {
                                    chartType: "bigNumberChart",
                                    chartId: "bigNumberChartOne",
                                    chartQuery:
                                      "/unified_temporary/home/activeGasContracts",
                                    idQuery: "getActiveGasContracts",
                                  },
                                ],
                              }}
                              municipalitiesToFetch={entityToFetch?.value}
                              yearsToFetch={yearsToFetch}
                            />
                            <Widget
                              data={{
                                height: "150px",
                                border: "neutral-3",
                                title: "buildingsEvaluated", //Traduções
                                icon: "Building",
                                tooltip: t("buildingsEvaluatedTooltip"),
                                charts: [
                                  {
                                    chartType: "bigNumberChart",
                                    chartId: "bigNumberChartOne",
                                    chartQuery:
                                      "/unified_temporary/home/evaluatedBuildings",
                                    idQuery: "getEvaluatedBuildings",
                                  },
                                ],
                              }}
                              municipalitiesToFetch={entityToFetch?.value}
                              yearsToFetch={yearsToFetch}
                            />
                          </Flex>
                        </Col>
                        <Col span={12}>
                          <Widget
                            data={{
                              height: "482px",
                              border: "neutral-3",
                              title: "electricityConsumptionByType", //Traduções
                              icon: "Bolt",
                              tooltip: (
                                <MouseoverTooltip data={tooltipContent} />
                              ),
                              charts: [
                                {
                                  chartType: "treemapChartApex",
                                  height: "100%",
                                  width: "100%",
                                  chartId: "treemapChartOne",
                                  chartQuery:
                                    "/unified_temporary/home/consumeByTypology",
                                  idQuery: "getConsumeByTypology",
                                },
                              ],
                            }}
                            municipalitiesToFetch={entityToFetch?.value}
                            yearsToFetch={yearsToFetch}
                          />
                        </Col>
                      </Row>
                      <Row gutter={[32, 32]}>
                        <Col span={6}>
                          <Widget
                            data={{
                              height: "447px",
                              width: "auto",
                              background: null,
                              border: "neutral-3",
                              title: "topConsumers",
                              icon: "Bolt",
                              description: null,
                              tooltip: t("comparingElectricityConsumption"),
                              charts: [
                                {
                                  chartType: "horizontalBarChartApex",
                                  height: "100%",
                                  width: "100%",
                                  chartId: "topConsumersCharts",
                                  chartQuery: "/unified_temporary/home/topConsumers",
                                  idQuery: "getTopConsumers",
                                },
                              ],
                            }}
                            municipalitiesToFetch={entityToFetch?.value}
                            yearsToFetch={yearsToFetch}
                          />
                        </Col>
                        <Col span={6}>
                          <Widget
                            data={{
                              height: "447px",
                              width: "auto",
                              background: null,
                              border: "neutral-3",
                              title: "electricityConsumptionByType",
                              icon: "Bolt",
                              description: null,
                              tooltip: null,
                              charts: [
                                {
                                  chartType: "dataChart",
                                  height: "100%",
                                  width: "100%",
                                  chartQuery:
                                    "/unified_temporary/home/yearConsumeByGroups",
                                  idQuery: "getYearConsumeByGroups",
                                  chartId: "dataChartOne",
                                },
                              ],
                            }}
                            municipalitiesToFetch={entityToFetch?.value}
                            yearsToFetch={yearsToFetch}
                          />
                        </Col>
                        <Col span={12}>
                          <Widget
                            data={{
                              height: "447px",
                              width: "auto",
                              background: null,
                              border: "neutral-3",
                              title: "monthlyElectricityConsumption",
                              icon: "Bolt",
                              charts: [
                                {
                                  chartType: "columnsChartApex",
                                  chartId: "barChartWithMultiXAxisOne",
                                  chartQuery:
                                    "/unified_temporary/home/averageConsumeForMonth",
                                  idQuery: "getAutarchyAverageConsumeForMonth",
                                },
                              ],
                            }}
                            municipalitiesToFetch={entityToFetch?.value}
                            yearsToFetch={yearsToFetch}
                          />
                        </Col>
                      </Row>
                    </Flex>
                  </Flex>
                  <div className="solve-error" id="territory"></div>{" "}
                  {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
                </PageSection>
              ) : null}
              {tags?.includes("territory") ? (
                <PageSection className="ant-anchors-content-item section">
                  <Text
                    $fontColor="coolgray-12"
                    $fontSize="text_xl"
                    $weight="regular"
                    $marginBottom="s08"
                  >
                    {t("territory")}
                  </Text>
                  <Flex gap={32} vertical="true">
                    <Row gutter={[32, 32]}>
                      <Col span={18}>
                        <Widget
                          data={{
                            height: "482px",
                            background: "white",
                            title: "monthlyElectricityConsumption",
                            icon: "Bolt",
                            tooltip: t("dataBasedEReded"),
                            charts: [
                              {
                                chartType: "columnsChartApex",
                                chartId: "barChartWithMultiXAxisTwo",
                                chartQuery:
                                  "/unified_temporary/home/monthlyConsumptionOfElectricity",
                                idQuery: "getMonthlyConsumptionOfElectricity",
                              },
                            ],
                          }}
                          municipalitiesToFetch={entityToFetch?.value}
                          yearsToFetch={yearsToFetch}
                        />
                      </Col>
                      <Col span={6}>
                        <Flex gap={16} vertical="true">
                          <Widget
                            data={{
                              height: "150px",
                              background: "white",
                              title: "anualElectricityConsumptionTotal",
                              icon: "Bolt",
                              tooltip: (
                                <MouseoverTooltip
                                  data={{
                                    iconText: [
                                      { text: t("dataBasedEReded") },
                                      { text: t("accumulatedTooltip") },
                                    ],
                                  }}
                                />
                              ),
                              charts: [
                                {
                                  chartType: "bigNumberChart",
                                  chartId: "bigNumberChartThree",
                                  chartQuery:
                                    "/unified_temporary/home/territoryByVoltageLevelTotal",
                                  idQuery: "getTerritoryByVoltageLevelTotal",
                                },
                              ],
                            }}
                            municipalitiesToFetch={entityToFetch?.value}
                            yearsToFetch={yearsToFetch}
                          />
                          <Widget
                            data={{
                              height: "150px",
                              width: "auto",
                              background: "white",
                              // border: 'neutral-3',
                              title: "anualElectricityConsumptionMtAtMat",
                              icon: "Bolt",
                              tooltip: (
                                <MouseoverTooltip
                                  data={{
                                    iconText: [
                                      { text: t("dataBasedEReded") },
                                      { text: t("accumulatedTooltip") },
                                    ],
                                  }}
                                />
                              ),
                              charts: [
                                {
                                  chartType: "bigNumberChart",
                                  chartId: "bigNumberChartThree",
                                  chartQuery:
                                    "/unified_temporary/home/territoryByVoltageLevelLowTension",
                                  idQuery:
                                    "getTerritoryByVoltageLevelLowTension",
                                },
                              ],
                            }}
                            municipalitiesToFetch={entityToFetch?.value}
                            yearsToFetch={yearsToFetch}
                          />
                          <Widget
                            data={{
                              height: "150px",
                              background: "white",
                              // border: 'neutral-3',
                              title: "anualElectricityConsumptionBtnBte",
                              icon: "Bolt",
                              tooltip: (
                                <MouseoverTooltip
                                  data={{
                                    iconText: [
                                      { text: t("dataBasedEReded") },
                                      { text: t("accumulatedTooltip") },
                                    ],
                                  }}
                                />
                              ),
                              charts: [
                                {
                                  chartType: "bigNumberChart",
                                  chartId: "bigNumberChartThree",
                                  chartQuery:
                                    "/unified_temporary/home/territoryByVoltageLevelHigh",
                                  idQuery: "getTerritoryByVoltageLevelHigh",
                                },
                              ],
                            }}
                            municipalitiesToFetch={entityToFetch?.value}
                            yearsToFetch={yearsToFetch}
                          />
                        </Flex>
                      </Col>
                    </Row>
                    <Row gutter={[32, 32]}>
                      <Col span={6}>
                        <Widget
                          data={{
                            height: "447px",
                            background: "white",
                            title: "totalPowerInstalledQuarterConsumption",
                            icon: "Clipboard",
                            tooltip: t("dataBasedEReded"),
                            charts: [
                              {
                                chartType: "columnsChartApex",
                                chartId: "barChartWithMultiXAxisOne",
                                chartQuery:
                                  "/unified_temporary/home/territoryAutoconsumption",
                                idQuery: "getTerritoryAutoconsumption",
                              },
                            ],
                          }}
                          municipalitiesToFetch={entityToFetch?.value}
                          coordinates={entityCoordinates}
                          yearsToFetch={yearsToFetch}
                        />
                      </Col>
                      <Col span={18}>
                        <Widget
                          data={{
                            id: "map",
                            height: "447px",
                            background: "white",
                            title: "territoryConsumptionDensity",
                            icon: "Clipboard",
                            tooltip: (
                              <MouseoverTooltip
                                data={{
                                  iconText: [
                                    { text: t("heatmapExplained") },
                                    { text: t("heatmapTooltip") },
                                  ],
                                }}
                              />
                            ),
                            map: {
                              type: "heatmap",
                            },
                          }}
                          municipalitiesToFetch={entityToFetch?.value}
                          coordinates={entityCoordinates}
                          yearsToFetch={yearsToFetch}
                        />
                      </Col>
                    </Row>
                  </Flex>
                  <div className="solve-error" id="emissions"></div>{" "}
                  {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
                </PageSection>
              ) : null}
              {tags?.includes("emissions") ? (
                <PageSection className="ant-anchors-content-item section">
                  <Text
                    $fontColor="coolgray-12"
                    $fontSize="text_xl"
                    $weight="regular"
                    $marginBottom="s08"
                  >
                    {t("emissions")}
                    <Tooltip
                      className="widget-tooltip"
                      title={t("dataRefersToYear") + cirisMostRecentYear}
                      color={Theme.color.white}
                      colorText={Theme.color["coolgray-12"]}
                    >
                      <Button
                        shape="circle"
                        type="text"
                        icon={
                          <CustomIcon
                            icon={"Information"}
                            iconsize="md"
                            color="blue-4"
                          />
                        }
                      />
                    </Tooltip>
                  </Text>
                  {cirisMostRecentYear ? (
                    <Row gutter={[32, 32]}>
                      <Col span={12}>
                        <Widget
                          key={1}
                          data={{
                            height: "447px",
                            background: "white",
                            border: null,
                            title: "sectorCO2Emissions",
                            icon: "Emissions",
                            charts: [
                              {
                                chartType: "simpleDonutChartApex",
                                chartId: "donutChartOne",
                                chartQuery:
                                  "/unified_temporary/ciris/emissionsBySector",
                              },
                            ],
                          }}
                          yearsToFetch={[cirisMostRecentYear]}
                          municipalitiesToFetch={entityToFetch?.value}
                        />
                      </Col>
                      <Col span={12}>
                        <Widget
                          key={2}
                          data={{
                            height: "447px",
                            background: "white",
                            title: "evolutionBySector",
                            icon: "Emissions",
                            tooltip: (
                              <MouseoverTooltip
                                data={{
                                  iconText: [
                                    { text: t("AFOLUTooltip") },
                                    { text: t("IPPUTooltip") },
                                  ],
                                }}
                              />
                            ),
                            charts: [
                              {
                                chartType: "stackedColumnsChartApex",
                                chartQuery:
                                  "/unified_temporary/ciris/evolutionBySector",
                                idQuery: "getEvolutionBySector",
                                chartId: "verticalStackedBarChartOne",
                              },
                            ],
                          }}
                          municipalitiesToFetch={entityToFetch?.value}
                        />
                      </Col>
                    </Row>
                  ) : null}
                </PageSection>
              ) : null}
            </>
          ) : null}
        </>
        {/* } */}
      </div>
    </PageContent>
  );
};